// extracted by mini-css-extract-plugin
module.exports = {"flex":"Navbar_flex__1BnLb","link_parent":"Navbar_link_parent__2kDq4"};